import   React       , 
       { useState    , 
         useEffect   , 
         useRef      , 
         ChangeEvent } from "react";
         
import   classNames    from "classnames";

import   styles        from "./Field.module.scss";

export interface FieldColorProps {
  placeholder?  : string;
  value?        : string | number;
  readOnly?     : boolean;
  onChange?     : (event: React.ChangeEvent<HTMLInputElement>, value: string | number | File | Date, duration?: string) => void;
  width?        : string;
  height?       : string;
  glowColor?    : string;
  showField?    : boolean;
}

export const FieldColor = ({ placeholder                 ,
                             value       = ""            ,
                             readOnly                    ,
                             onChange                    ,
                             width       = "100%"        ,
                             height      = "fit-content" ,
                             glowColor   = "var(--color-Field-Focus-normal)"     ,
                             showField   = true          }: FieldColorProps) => {
                            
  const fieldStyle = { "--glow-color": glowColor } as React.CSSProperties;

  const [ inputValue , setInputValue ] = useState(value);
  const [ hasFocus   , setHasFocus   ] = useState(false);

  const colorInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
      
    if (!hasFocus) 
     {
      setInputValue(value);
     }
  }, [value, hasFocus]);


  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      
    const input = event.target.value;

    setInputValue(input);
    
    if (onChange) onChange(event, input);
  };


  const renderInput = (): JSX.Element => {
      
    const textInputProps = {
        
      className : classNames(styles.field_input),
      value     : inputValue,
      onChange  : (e: ChangeEvent<HTMLInputElement>) => handleChange(e),
      onFocus   : () => setHasFocus(true),
      onBlur    : () => setHasFocus(false),
      placeholder,
      readOnly,
    };

    return (
              <div className={classNames(styles.field_with_icon, styles.color_picker)}>
                
				{
                 showField &&
                 (
                  <input {...textInputProps}
                         type        = "text"
                         placeholder = {placeholder || "#FFFFFF"}
                         onChange    = {(e: ChangeEvent<HTMLInputElement>) => handleChange(e)} />
				 )
				}
                
				{/* Juste pour avoir accès à la palette de couleur */}
				<input ref      = {colorInputRef}
                       type     = "color"
                       value    = {inputValue as string}
                       onChange = {(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
                       style    = {{ opacity: 0, position: 'absolute', pointerEvents: 'none' }} />
            
			    <button className = {classNames(styles.color_preview_button)}
                        style     = {{ backgroundColor: inputValue as string }}
                        onClick   = {() => {
                                            if (colorInputRef.current) 
											 {
                                              colorInputRef.current.click();
                                             }
                                           }}   />
              </div>
           );
    
  };

  return (
    <div className = {classNames(styles.field)} 
	     style     = {{ width, height, ...fieldStyle }}>
      {renderInput()}
    </div>
  );
};

export default FieldColor;
